import { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';
import { PROJECT_FILTERS, PROJECTS } from '../../data/siteData';

const Lightbox = ({ project, onClose }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    const { overflow } = document.body.style;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = overflow;
    };
  }, [onClose]);

  return (
    <div
      className="lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={project.title}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <button ref={closeRef} type="button" className="close" onClick={onClose}>
        Close <X size={14} style={{ display: 'inline', verticalAlign: '-2px' }} />
      </button>
      <figure>
        <img src={project.image} alt={`${project.title} BIM model`} />
        <figcaption>{project.title} · BIM Modeling</figcaption>
      </figure>
    </div>
  );
};

export const ProjectGallery = ({ limit, showFilters = true }) => {
  const [filter, setFilter] = useState('all');
  const [open, setOpen] = useState(null);
  const lastTrigger = useRef(null);

  const items = (limit ? PROJECTS.slice(0, limit) : PROJECTS).filter(
    (p) => filter === 'all' || p.category === filter
  );

  const close = () => {
    setOpen(null);
    lastTrigger.current?.focus();
  };

  return (
    <div data-testid="project-gallery">
      {showFilters && (
        <div className="filters" role="group" aria-label="Filter projects">
          {PROJECT_FILTERS.map((f) => {
            const count = f.id === 'all' ? PROJECTS.length : PROJECTS.filter((p) => p.category === f.id).length;
            return (
              <button key={f.id} type="button" aria-pressed={filter === f.id} onClick={() => setFilter(f.id)}>
                {f.label}<span className="ct">{count}</span>
              </button>
            );
          })}
        </div>
      )}
      <div className="gal">
        {items.map((p) => (
          <button
            key={`${filter}-${p.title}`}
            type="button"
            className={`${p.wide ? 'wide ' : ''}fade`}
            onClick={(e) => {
              lastTrigger.current = e.currentTarget;
              setOpen(p);
            }}
            aria-label={`View ${p.title}`}
          >
            <img src={p.image} alt="" loading="lazy" />
            <span className="cap"><small>BIM Modeling</small>{p.title}</span>
          </button>
        ))}
      </div>
      {open && <Lightbox project={open} onClose={close} />}
    </div>
  );
};

export default ProjectGallery;
